export enum GameSimulatorTabs {
  SELECT_TEAM = 'Select Team',
  SIMULATE_SEASON = 'Simulate Season',
  ADJUST_LINEUPS = 'Adjust Lineups',
}
